<template>
  <div class="reviews">
    <div class="container">
      <div class="reviews__wrapper">
        <div class="reviews__wrapper-left">
          <p class="reviews__wrapper-title">{{ t('home.review.title') }}</p>
          <p class="reviews__wrapper-title">{{ t('home.review.subtitle') }}</p>
          <img src="@images/vectors/reviews/stars.svg" alt="vector">
        </div>
        <div class="reviews__wrapper-right">
          <p class="reviews__wrapper-text">{{ t('home.review.text') }}</p>
          <img src="@images/vectors/reviews/blueVector.svg" alt="vector">
        </div>
      </div>
    </div>
    <vue-marquee-slider
      class="reviews__marquee"
      :speed="20000"
      :space="15"
      :paused="isMarqueePaused"
      @mouseenter="isMarqueePaused = true"
      @mouseleave="isMarqueePaused = false"
    >
      <div class="reviews__item" v-for="idx in 6" :key="idx">
        <div class="reviews__item-avatar"></div>
        <div class="reviews__item-inner">
          <p class="reviews__item-title">George B. <span><img v-for="idx in 1" :key="idx" src="@images/vectors/reviews/reviewStar.svg" alt="star"></span></p>
          <p class="reviews__item-text">Awesome!! Blah Blah Blah...</p>
        </div>
      </div>
    </vue-marquee-slider>
  </div>
</template>

<script setup>
import {VueMarqueeSlider} from "vue3-marquee-slider";
import '../../../node_modules/vue3-marquee-slider/dist/style.css'
import {useI18n} from "vue-i18n";
import {ref} from "vue";

const {t} = useI18n()

const isMarqueePaused = ref(false)
</script>

<style lang="scss" scoped>
.reviews {
  padding-block: 100px 75px;
  display: flex;
  flex-direction: column;
  gap: 50px;

  &__wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 200px;

    &-left {
      position: relative;

      & img {
        position: absolute;
        right: 150px;
        top: -40px;
      }
    }

    &-right {
      width: 575px;
      position: relative;

      & img {
        position: absolute;
        right: 30px;
        bottom: 0;
      }
    }

    &-title {
      font-family: Poppins, sans-serif;
      font-size: 38px;
      font-weight: 500;
    }

    &-text {
      font-family: Poppins,sans-serif;
      font-size: 18px;
      font-weight: 400;
      color: #2a2a2a;
    }
  }

  &__marquee {
    background-color: #c0c59b;
    padding-block: 20px;
  }

  &__item {
    border-radius: 8px;
    background-color: #628776;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 7px 15px;
    flex-shrink: 0;

    &-avatar {
      border-radius: 50%;
      width: 58px;
      aspect-ratio: 1;
      background-color: red;
      flex-shrink: 0;
    }

    &-inner {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    &-title {
      font-size: 20px;
      font-weight: 700;
      color: $white;
    }

    &-text {
      font-size: 11px;
      font-weight: 700;
      color: $white;
    }
  }
}

@media (max-width: 1680px) {
  .reviews {
    &__wrapper {
      gap: 50px;
    }
  }
}

@media (max-width: 1300px) {
  .reviews {
    &__wrapper {
      &-left {
        & img {
          top: -84px;
        }
      }

      &-right {
        & img {
          bottom: -25px;
        }
      }
    }
  }
}

@media (max-width: 850px) {
  .reviews {
    &__wrapper {
      flex-direction: column;
    }
  }
}

@media (max-width: 600px) {
  .reviews {
    &__wrapper {
      &-right {
        width: 90%;
      }
    }
  }
}

@media (max-width: 450px) {
  .reviews {
    &__wrapper {
      &-title {
        font-size: 32px;
      }

      &-left {
        & img {
          right: 0;
        }
      }

      &-right {
        & img {
          right: 0;
          width: 100%;
        }
      }
    }
  }
}
</style>